import * as React from 'react';

// Modules
import { DI } from 'modules';

const DownloadSliderFreeAccess = ({ common }) => {
  const { strings } = common;

  // Root className
  const rootCln = 'side-buy-plan';

  return (
    <div className={`${rootCln} ${rootCln}--free`}>
      <div className={`${rootCln}__text`}>
        {strings['page.video.slider.is_free_content']}
      </div>
    </div>
  );
};

export default DI(['common'])(DownloadSliderFreeAccess);
